import { Sparkles } from 'lucide-react';

export const FoundingPhilosophyBadge = () => {
  return (
    <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-primary/10 via-accent/10 to-primary/10 border border-primary/20 backdrop-blur-sm">
      <Sparkles className="w-4 h-4 text-primary" />
      <span className="text-sm font-medium text-foreground">Founding Philosophy</span>
    </div>
  );
};
